export default __webpack_public_path__ + "static/media/signin_logo.33c155b1.svg";